package com.ucasoft.komm.website.data

import com.ucasoft.komm.website.components.code.CodeData

data class Step(val title: String, val description: String, val codes: List<CodeData>)